// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__8H7Wc","col":"styles_col__1w5my"};